import type { DiagramProps } from '@/lib/scad-feature-types';
import { D } from './DiagramStyles';

export function SquareDiagram({ values }: DiagramProps) {
  const width = Math.max(1, values.width ?? 10);
  const height = Math.max(1, values.height ?? 10);
  const centered = values.center ?? true;

  const maxDim = Math.max(width, height, 1);
  const scale = 80 / maxDim;
  const dW = Math.min(110, Math.max(16, width * scale));
  const dH = Math.min(90, Math.max(16, height * scale));

  // Position rectangle centered or from origin
  const ox = 100, oy = 75;
  const rx = centered ? ox - dW / 2 : ox;
  const ry = centered ? oy - dH / 2 : oy - dH;

  const originX = centered ? ox : ox;
  const originY = centered ? oy : oy;

  return (
    <svg viewBox="0 0 280 150" width="100%" style={{ display: 'block' }} aria-label="Square/Rectangle diagram">
      <defs>
        <marker id="arr-sq" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
          <path d="M0,1 L5,3 L0,5 Z" fill={D.DIM_STROKE} />
        </marker>
        <marker id="arr-sq-rev" markerWidth="6" markerHeight="6" refX="1" refY="3" orient="auto">
          <path d="M5,1 L0,3 L5,5 Z" fill={D.DIM_STROKE} />
        </marker>
      </defs>

      {/* 2D label */}
      <text x="18" y="18" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.35">[2D shape]</text>

      {/* Rectangle */}
      <rect x={rx} y={ry} width={dW} height={dH}
            fill={D.GEO_FILL} stroke={D.GEO_STROKE} strokeWidth="1.5" />

      {/* Width dimension */}
      <line x1={rx} y1={ry + dH + 10} x2={rx + dW} y2={ry + dH + 10}
            stroke={D.X_COLOR} strokeWidth="1" strokeDasharray={D.DIM_DASH}
            markerEnd="url(#arr-sq)" markerStart="url(#arr-sq-rev)" />
      <text x={rx + dW / 2} y={ry + dH + 22} fontSize="10" fontFamily="monospace"
            fill={D.X_COLOR} textAnchor="middle" opacity="0.9">width={width}</text>

      {/* Height dimension */}
      <line x1={rx + dW + 10} y1={ry} x2={rx + dW + 10} y2={ry + dH}
            stroke={D.Y_COLOR} strokeWidth="1" strokeDasharray={D.DIM_DASH}
            markerEnd="url(#arr-sq)" markerStart="url(#arr-sq-rev)" />
      <text x={rx + dW + 14} y={ry + dH / 2 + 4} fontSize="10" fontFamily="monospace"
            fill={D.Y_COLOR} textAnchor="start" opacity="0.9">height={height}</text>

      {/* Origin cross */}
      <line x1={originX - 4} y1={originY} x2={originX + 4} y2={originY}
            stroke={D.ORIGIN_COLOR} strokeWidth="1.2" />
      <line x1={originX} y1={originY - 4} x2={originX} y2={originY + 4}
            stroke={D.ORIGIN_COLOR} strokeWidth="1.2" />

      <text x="8" y="142" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.45">
        {centered ? 'center=true' : 'center=false'}
      </text>
    </svg>
  );
}
